import React, { useState, useEffect } from 'react';
import LoggedInLayout from '../../layout/LoggedInLayout';
import { Box, Grid2, Paper, Typography, LinearProgress, Divider, CircularProgress, Card, Avatar, IconButton } from '@mui/material';
import CommonDropdown from '../common/CommonDropdown';
import httpcommon from '../../helper/httpcommon';
import { useToast } from '../../hook/useToast';
import SuggestionsCarousel from './SuggestionsCarousel';
import EminentParsons from './EminentParsons';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(243, 243, 245, 1)',
    height: '46px',
    borderRadius: '6px',
    paddingLeft: '12px',
    marginLeft: '5px',
    marginBottom: '24px',
    width: '95%',
  },
  formContainer: {
    width: '70%',
    marginLeft: '60px',
    marginTop: '30px',
  },

  backBtn: {
    padding: 0,
    marginRight: '8px',
    width: "28px",
    height: "28px",
    backgroundColor: 'rgba(255, 255, 255, 1)',
    borderRadius: '50%',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
  },

  backIcon: {
    fontSize: '22px',
    color: 'rgba(157, 158, 158, 1)',
  },
  pageHeading: {
    fontSize: '15px',
    fontWeight: 500,
    color: '#231F20',
  },

};
const LeaderTraits = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    career: '',
  });
  const [loading, setLoading] = useState(true);
  const { showToast } = useToast();
  const [careerOptions, setCareerOptions] = useState([]);
  const [statisticsData, setStatisticData] = useState({});

  const getCareers = async () => {
    try {
      setLoading(true)
      const response = await httpcommon.get('/school/leadership-traits/');
      if (response.status === 200 && response?.data?.length) {
        const formatted = response.data.map(item => ({
          label: toTitleCase(item.leadership_trait_name),
          value: item.leadership_trait_name
        }));

        setCareerOptions(formatted);
        setFilters((prevFilters) => ({
          ...prevFilters,
          career: formatted[0]?.value || '',
        }));

        // showToast('Data fetched successfully', 'success');
      } else {
        setCareerOptions([]);
      }
    } catch (error) {
      if (error.status != 404) {
        showToast(error.response?.data?.error || 'Error fetching data', 'error');
      }
      setCareerOptions([]);
    } finally {
      setLoading(false);
    }
  };
  function toTitleCase(str) {
    return str
      .split('_') // Split by underscore
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' '); // Join with space
  }
  const getStatisticsData = async () => {
    try {
      setLoading(true)
      const response = await httpcommon.get(`/school/leadership-traits/${filters.career}/`);
      if (response.status === 200 && response.data) {
        setStatisticData(response.data);
        // showToast('Data fetched successfully', 'success');
      } else {
        setStatisticData({});
      }
    } catch (error) {
      if (error.status != 404) {
        showToast(error.response?.data?.error || 'Error fetching data', 'error');
      }
      setStatisticData({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCareers();
  }, []);

  useEffect(() => {
    if (filters.career) {
      getStatisticsData();
    }
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };




  // Helper function to check if a category should be skipped
  const shouldSkipCategory = (category) => {
    const skipCategories = [
      "leadership_trait_name",
      "tips",
      "suggestions",
      "Subject Results" // Skip this if it exists from previous imports
    ];
    return skipCategories.includes(category);
  };

  return (
    <LoggedInLayout>
      <Box className="leader-traits">
        {/* Header */}
        <Box sx={styles.header}>
          <IconButton onClick={() => {
            navigate(-1);
          }} sx={styles.backBtn}>
            <ArrowBack sx={styles.backIcon} />
          </IconButton>

          <Typography sx={styles.pageHeading}>
            Professional DNA                     </Typography>
        </Box>
        {/* Page Header */}
          <Box sx={{ ml: 4, mb: 2, width: "90%" }}>
                  <Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
                  After studying over ten thousand professionals across different fields , we built the career DNA framework.
It highlights the unique qualities they possess. Now it's your time to create your own checklist , discover
your strengths, and use them to succeed in your chosen career.
                  </Typography>
                </Box>
        <Box display="flex" justifyContent={"right"}>
          <CommonDropdown
            roundBorder
            onChange={handleFilterChange}
            value={filters.career || ''}
            options={careerOptions}
            name="career"
            label="Select Career"
            width={"300px"}
          />
        </Box>

        {/* Conditional Loading or Main Content */}
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
            <CircularProgress />
          </Box>
        ) : (
          <>
            {/* Statistics Grid */}
            <Grid2 container spacing={2}>
              {statisticsData &&
                Object.entries(statisticsData).map(([title, data]) => {
                  // Skip individual subject categories
                  if (shouldSkipCategory(title)  || (Array.isArray(data) && data.length === 0)  ) {
                    return null;
                  }

                  return (
                    <Grid2 key={title} gapE={2} size={{ xs: 12, sm: 12, md: 6, lg: 4 }}>
                      <Paper
                        elevation={0}
                        sx={{
                          height: "100%",
                          minHeight: "200px",
                          minWidth: "250px",
                          background: "#fff",
                          boxShadow: "0px 4px 12px rgba(96, 93, 93, 0.08)",
                          overflow: "hidden",
                          display: "flex",
                          flexDirection: "column",
                        }}


                      >
                        {/* Header */}
                        <Box
                          sx={{
                            backgroundColor: "RGB(41, 46, 92)",
                            padding: "10px 15px",
                            borderTopLeftRadius: "20px",
                            borderTopRightRadius: "0px",
                            borderBottomLeftRadius: "0px",
                            borderBottomRightRadius: "0px",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#fff",
                              fontSize: "16px",
                              fontWeight: 500,
                              textTransform: "capitalize",
                            }}
                          >
                            {toTitleCase(title)}
                          </Typography>
                        </Box>

                        {/* Card Body */}
                        <Box
                          sx={{
                            border: "1px solid #a9a4a4",
                            marginTop: "10px",
                            padding: "5px",
                            borderTopLeftRadius: "10px",
                            height: "100%"


                          }}
                        >
                          <ul>

                            {statisticsData[title] &&
                              Array.isArray(statisticsData[title]) &&
                              statisticsData[title].length > 0 &&
                              statisticsData[title].map((label, index) => (
                                <li>
                                  <Typography
                                    key={index}
                                    sx={{
                                      fontSize: "15px",
                                      color: "#000",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {label}
                                  </Typography>
                                </li>

                              ))}
                          </ul>

                        </Box>
                      </Paper>
                    </Grid2>
                  );
                })}
            </Grid2>
            {/* Add Subject Performance card */}
            {/* <Box>


              <SuggestionsCarousel suggestions={statisticsData.suggestions} />
            </Box>
            <Box >


              <EminentParsons suggestions={statisticsData.suggestions || []}></EminentParsons>
            </Box> */}


          </>
        )}
      </Box>

    </LoggedInLayout>
  );
};

export default LeaderTraits;